<template lang="pug">
section.comments-container
  section.comments-qa(v-if="isFaqExists")
    h1.faq-title {{ $t('comments.qaTitle') }}
    .goto-questions
      a(href="#goto-question")
        i.fa.fa-hand-paper-o
        span {{ $t('comments.goToQuestion') }}
    article
      ul
        li.faq(v-for="item in getBuilder.faq", :key="item.id")
          p.question(v-html="item.subject")
          div.answer(v-html="item.answer")
  hr
  //- 未登入狀態 的留言區塊
  #goto-question.comment__row.comment__leave-message.card.card-invert.border-radius.no-padding(v-if="!isLogin && checkLoginStatus")
    a(@click.stop="saveReferrerUrl()").btn.btn-warning.btn-lg.btn-block {{ $t('comments.loginToContinue') }}

  //- 登入中狀態 的留言區塊
  #goto-question.comment__row.comment__leave-message.card.card-default.border-radius(v-if="isLogin && checkLoginStatus")
    comment-form(:user-data="getUserData",
      :contest-content-id="getBuilder.ccontestContentId",
      :is-highlighted="getBuilder.isHighlighted",
      :contest-organizer-id="getBuilder.organizer")

  hr
  div#highlight-comment(v-if="isHighlightComment")
    .comment__row.card.card-default.border-radius(:class="{ 'highlight-comment': isHighlightCommentTarget(getHighlightComment.ccid) }")
      .comment__row__avatar.pull-left
        img.img-circle(v-if="getHighlightComment.avatar !== false", :src="getHighlightComment.avatar")
        img.img-circle(v-else, :src="noUserAvatar(comment.uid)")
      .comment__row__content
        .comment__row__content__user(v-if="getHighlightComment.ccid === 0")
          span.private-comment(v-if="getHighlightComment.isPrivate") {{ $t('comments.private') }}
        .comment__row__content__user(v-else)
          span.comment__row__content__user__name
            span {{ getHighlightComment.nickname }}
            span.private-comment(v-if="getHighlightComment.isPrivate") {{ $t('comments.private') }}
          span.comment__row__content__user__reply-time {{ formatDatelineFromNow(getHighlightComment.created) }}
        .comment__row__content__text(v-html="getHighlightComment.body")
        .comment__row__action(v-if="isLogin && getHighlightComment.ccid > 0 && checkLoginStatus")
          button.comment__row__action__reply.btn-link(@click.stop="replyComments(getHighlightComment.ccid)") {{ $t('comments.replyComment') }}
    div(v-if="getHighlightComment.subComments.current < getHighlightComment.subComments.totalPages")
      .comment.comment__replylist
        .comment__row.card.card-blank.border-radius
          button.btn.btn-default.btn__comments.btn__comments--load-pre.submit-button(type="button", @click.stop="loadMoreSubComments(getHighlightComment.subComments, getHighlightComment.ccid, true)")  {{ $t('comments.loadMoreComments') }}
    .comment.comment__replylist(v-for="reply in getHighlightComment.subComments.items")
      //- organizer add the .comment__row__organizer class for card
      .comment__row.card.card-default.border-radius(
        :class="{ 'comment__row__organizer': getHighlightComment.uid === getBuilder.organizerProfileUid, 'highlight-comment': isHighlightCommentTarget(reply.ccid) }")
        .comment__row__avatar.pull-left
          img.img-circle(v-if="reply.avatar !== false", :src="reply.avatar")
          img.img-circle(v-else, :src="noUserAvatar(reply.uid)")
        .comment__row__content
          .comment__row__content__user(v-if="reply.ccid === 0")
            span(v-if="reply.isPrivate") {{ $t('comments.private') }}
          .comment__row__content__user(v-else)
            i.glyphicon.glyphicon-education(v-if="reply.uid === getBuilder.organizerProfileUid")
            span {{ reply.nickname }}
          .comment__row__content__text(v-html="reply.body")
          .comment__row__action(v-if="isLogin && reply.ccid > 0 && checkLoginStatus")
            button.comment__row__action__reply.btn-link(@click.stop="replyComments(reply.ccid, getHighlightComment.ccid)") {{ $t('comments.replyComment') }}
            span.comment__row__content__user__reply-time {{ formatDatelineFromNow(reply.created) }}
    .comment.comment__replylist
      //- 按下回覆後 登入中狀態 出現的留言區塊
      .comment__row.comment__leave-message.card.card-default.border-radius(v-if="isLogin && checkLoginStatus && getHighlightComment.openReply")
        comment-form(:comment="getHighlightComment",
          :contest-content-id="getBuilder.contestContentId",
          :is-highlighted="getBuilder.isHighlighted",
          :is-highlight-comment="true",
          :user-data="getUserData",
          :contest-organizer-id="getBuilder.organizer")
  //- normal_comment
  div(v-for="comment in getComments.items")
    .comment__row.card.card-default.border-radius(
      :class="{ 'comment__row__organizer': comment.uid === getBuilder.organizerProfileUid }")
      .comment__row__avatar.pull-left
        img.img-circle(v-if="comment.avatar !== false", :src="comment.avatar")
        img.img-circle(v-else, :src="noUserAvatar(comment.uid)")
      .comment__row__content
        .comment__row__content__user(v-if="comment.ccid === 0")
          span.private-comment(v-if="comment.isPrivate") {{ $t('comments.private') }}
        .comment__row__content__user(v-else)
          span.comment__row__content__user__name
            span {{ comment.nickname }}
            span.private-comment(v-if="comment.isPrivate") {{ $t('comments.private') }}
          a.comment__row__content__user__reply-time(:href="'?comment=' + comment.ccid") {{ formatDatelineFromNow(comment.created) }}
          //- span.comment__row__content__user__reply-time {{ formatDatelineFromNow(comment.created) }}
        .comment__row__content__text(v-html="comment.body")
        .comment__row__action(v-if="isLogin && comment.ccid > 0 && checkLoginStatus")
          button.comment__row__action__reply.btn-link(@click.stop="replyComments(comment.ccid)") {{ $t('comments.replyComment') }}
    div(v-if="comment.subComments.current < comment.subComments.totalPages")
      .comment.comment__replylist
        .comment__row.card.card-blank.border-radius
          button.btn.btn-default.btn__comments.btn__comments--load-pre.submit-button(type="button", @click.stop="loadMoreSubComments(comment.subComments, comment.ccid)")  {{ $t('comments.loadMoreComments') }}
    .comment.comment__replylist(v-for="reply in comment.subComments.items")
      //- organizer add the .comment__row__organizer class for card
      .comment__row.card.card-default.border-radius(
        :class="{ 'comment__row__organizer': comment.uid === getBuilder.organizerProfileUid }")
        .comment__row__avatar.pull-left
          img.img-circle(v-if="reply.avatar !== false", :src="reply.avatar")
          img.img-circle(v-else, :src="noUserAvatar(reply.uid)")
        .comment__row__content
          .comment__row__content__user(v-if="reply.ccid === 0")
            span(v-if="reply.isPrivate") {{ $t('comments.private') }}
          .comment__row__content__user(v-else)
            i.glyphicon.glyphicon-education(v-if="reply.uid === getBuilder.organizerProfileUid")
            span {{ reply.nickname }}
          .comment__row__content__text(v-html="reply.body")
          .comment__row__action(v-if="reply.ccid > 0")
            button.comment__row__action__reply.btn-link(v-if="isLogin && checkLoginStatus", @click.stop="replyComments(reply.ccid, comment.ccid)") {{ $t('comments.replyComment') }}
            a.comment__row__content__user__reply-time(:href="'?comment=' + reply.ccid") {{ formatDatelineFromNow(reply.created) }}
            //- span.comment__row__content__user__reply-time {{ formatDatelineFromNow(reply.created) }}
    .comment.comment__replylist
      //- 按下回覆後 登入中狀態 出現的留言區塊
      .comment__row.comment__leave-message.card.card-default.border-radius(v-if="isLogin && checkLoginStatus && comment.openReply")
        comment-form(:comment="comment",
          :contest-content-id="getBuilder.contestContentId",
          :is-highlighted="getBuilder.isHighlighted",
          :user-data="getUserData",
          :contest-organizer-id="getBuilder.organizer")
  div(v-if="getComments.current < getComments.totalPages")
    button.btn.btn-default.btn__comments.btn__comments--load-next.submit-button(type="button", @click.stop="loadMoreComments()") {{ $t('comments.loadMoreComments') }}
</template>

<script>
import { distanceInWordsToNow, parse } from 'date-fns'
import { mapGetters, mapActions } from 'vuex'
import CommentForm from '@/components/CommentForm.vue'
import cookies from '@/utilities/cookies'

export default {
  name: 'comments',
  components: {
    commentForm: CommentForm
  },
  created () {
    this.watcher = this.$watch('getAuthCheckStatus', data => {
      if (typeof data !== 'undefined') {
        this.checkLoginStatus = true
      }
    })

    this.checkLoginStatus = this.getAuthCheckStatus !== 'undefined'
    this.$on('toggleHighlightComment', () => {
      let highlightComment = document.getElementById('highlight-comment')
      if (highlightComment) {
        window.scrollTo(0, highlightComment.offsetTop - 100)
      }
    })
  },
  methods: {
    noUserAvatar (userID = 0) {
      if (userID === this.getBuilder.organizerProfileUid) {
        return require('../assets/avatar_organizer.png')
      }
      if (this.isLogin) {
        if (userID === this.getUserData.uid) {
          if (this.getUserData.profile.gender === 'f') {
            return require('../assets/avatar_female.jpg')
          } if (this.getUserData.profile.gender === 'm') {
            return require('../assets/avatar_male.jpg')
          }
        }
      }
      return require('../assets/avatar.jpg')
    },
    isHighlightCommentTarget (id) {
      let comment = 0
      if (typeof window.location.search !== 'undefined') {
        let search = window.location.search.replace('?', '')
        search.split('&').every(item => {
          let keyValue = item.split('=')
          if (keyValue[0].toLowerCase() === 'comment') {
            if (typeof keyValue[1] !== 'undefined') {
              comment = parseInt(keyValue[1], 10)
              return false
            }
          }
        })
      }
      return comment === parseInt(id, 10)
    },
    saveReferrerUrl () {
      cookies.set('referrerUrl', window.location.href, { expires: 300 })
      const loginButton = document.getElementById('header-login-button')
      if (loginButton) {
        loginButton.click()
      } else {
        window.location.href = '/signup'
      }
    },
    formatDatelineFromNow (dateline) {
      if (typeof dateline !== 'undefined') {
        return distanceInWordsToNow(parse(dateline))
      }
      return ''
    },
    replyComments (targetId, parentCommentId) {
      this.triggerReplyComment({
        id: targetId,
        parent: parentCommentId,
        isHighlightComment: this.isHighlightComment
      })
    },
    loadMoreSubComments (comments, parentCommentId = 0, isHighlightComment = false) {
      if (comments.current < comments.totalPages) {
        let options = {
          parent: parentCommentId,
          page: comments.next,
          loadMore: true
        }
        if (isHighlightComment === true) {
          let comment = 0
          if (typeof window.location.search !== 'undefined') {
            let search = window.location.search.replace('?', '')
            search.split('&').every(item => {
              let keyValue = item.split('=')
              if (keyValue[0].toLowerCase() === 'comment') {
                if (typeof keyValue[1] !== 'undefined') {
                  comment = parseInt(keyValue[1], 10)
                  return false
                }
              }
            })
          }
          options = {
            comment: comment,
            isHighlightComment: isHighlightComment,
            limit: comments.limit,
            ...options
          }
        }

        this.fetchComments(options)
      }
    },
    loadMoreComments () {
      if (this.getComments.current < this.getComments.totalPages) {
        this.fetchComments({
          parent: 0,
          page: this.getComments.next,
          loadMore: true
        })
      }
    },
    ...mapActions({
      fetchComments: 'builder/fetchComments',
      triggerReplyComment: 'builder/triggerReplyComment'
    })
  },
  computed: {
    isLogin () {
      return (this.getToken !== '' &&
        typeof this.getToken !== 'undefined' &&
        typeof this.getUserData !== 'undefined' &&
        this.getUserData.uid !== 0)
    },
    isHighlightComment () {
      return Object.keys(this.getHighlightComment).length > 0 && this.getHighlightComment.ccid > 0
    },
    isFaqExists () {
      if (typeof this.getBuilder.faq !== 'undefined') {
        return this.getBuilder.faq.length > 0
      }
      return false
    },
    ...mapGetters({
      getToken: 'users/getToken',
      getUserData: 'users/getData',
      getBuilder: 'builder/getBuilder',
      getComments: 'builder/getComments',
      getHighlightComment: 'builder/getHighlightComment',
      getAuthCheckStatus: 'users/getAuthCheckStatus',
      getFaq: 'builder/getFaq'
    })
  },
  data () {
    return {
      checkLoginStatus: false,
      watcher: void 0,
      highlightComment: {
        avatar: false,
        status: '',
        ccid: 0,
        body: '',
        created: new Date(),
        openChildrenReply: false,
        openReply: false
      }
    }
  },
  beforeDestroy () {
    this.watcher()
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/variables.sass';

.comment {
  .card__extra-top {
    .title {
      color: $brown;
      font-size: 14px;
      font-weight: bold;
    }
  }
  &__leave-message {
    .card__extra-top {
      padding: 3px;
    }
  }
  &__row {
    &__avatar {
      margin-right: 10px;
      img {
        width: 36px;
        height: 36px;
      }
    }
    &__content {
      overflow: hidden;
      &__user {
        margin-bottom: 3px;
        &__name {
          font-weight: bold;
          margin-right: 4px;
        }
        &__reply-time {
          font-size: 12px;
          color: #888;
        }
      }
      &__text {
        font-size: 14px;
      }
    }
    &__action {
      button {
        padding: 0;
        margin: 0 6px 0 0;
        &:hover, &:focus {
          outline: none;
        }
        &.actived {
          color: $green;
        }
      }
      &__like {
        i {
          margin-right: 6px;
        }
        span {
          font-size: 13px;
        }
      }
    }
    &__organizer {
      box-shadow: 0 1px 2px rgba($green-1, 0.7), inset 0 1px 2px rgba($green, 0.7);
      &:hover {
        box-shadow: 0 0 0 2px rgba($green-1, 0.35);
      }
      .comment__row {
        &__avatar,
        &__content {
          &__name {
            i {
              color: $green;
              margin-right: 3px;
            }
            span {
              color: $green;
            }
          }
          &__text {
            color: $brown;
          }
        }
      }
    }
  }
  &__replylist {
    .comment__row {
      margin-left: 60px;
      &__avatar {
        margin-right: 10px;
        img {
          width: 26px;
          height: 26px;
        }
      }
    }
  }
}
.highlight-comment {
  border: 1px solid rgba(255, 0, 0, 0.45);
}
.private-comment {
  font-size: 12px;
  margin-left: 0.5em;
  display: inline-block;
  border-radius: 4px;
  background-color: #7A9E4C;
  color: white;
  padding: 1px 4px;
}
.comments-qa {
  max-width: 700px;
  margin: 0 auto;
  .faq-title {
    color: #666 !important;
    text-align: center;
    fnot-size: 24px;
    font-weight: bold;
  }
  .goto-questions {
    text-align: center;
    a, a:hover, a:active, a:visited, a:link {
      display: inline-block;
      span {
        color: #7a9e4c !important;
        text-decoration: underline;
        display: inline-block;
        margin-left: 0.5rem;
      }
    }
  }
  .platform-questions,
  .contest-questions {
    color: #E6BA1C !important;
    font-size: 22px !important;
  }
  .contest-questions {
    margin-top: 3rem !important;
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    li {
      padding: 0;
      margin: 0 0 1rem 0;
      p.question {
        font-weight: bold;
        border-bottom: 1px solid #e2e2e2;
        padding: 1rem 0;
        margin: 0;
        color: #666;
      }
      div.answer {
        color: #666;
        line-height: 1.5em;
      }
    }
  }
  /deep/ ol {
    padding-left: 1.2rem;
    li {
      padding: 0;
      margin: 0;
    }
  }
}
.btn__comments {
  width: 100%;
  &.btn__comments--load-pre,
  &.btn__comments--load-next {
    margin-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Comments.vue